const StatusBar = ({ isStarting, message, progress }) => (
  <div className="statusbar" style={{ marginBottom: "1rem" }}>
    <div className="message" style={{ fontSize: "0.95rem", opacity: 0.9 }}>
      <p>{message}</p>
    </div>
    {isStarting && (
      <div style={{ marginTop: 6, height: 6, background: "#eee", borderRadius: 4, overflow: "hidden" }}>
        <div style={{ width: `${progress}%`, height: "100%", background: "#09ff00ff" }} />
      </div>
    )}
  </div>
);

export default StatusBar;